module.exports = __webpack_public_path__ + "img/0f99e8a75f294e81abb3dff473edb827.57f55c81.jpg";